<template>
  <div class="personal-info">
    <div class="title">
      <img src="../../assets/icon/INFOICON.png" alt="" />
      <span>اطلاعات فردی</span>
    </div>

    <div class="box">
      <!-- <form>
   
                <custom-input placeholder="نام" type="text" @getValue="value => data.firstName = value" typeValue="text"  :disabled="readonly"/>
                <custom-input  placeholder="نام خانوادگی" type="text" @getValue="value => data.lastName = value" @setValue="value=> data.lastName = value" typeValue="text"  :disabled="readonly"/>
                <date-picker
                    class="main-box"
                    v-model="data.birthDay"
                    placeholder="تاریخ تولد"
                    :format="$dateFormat['en']"
                    :display-format="$dateFormat['fa']"
                    :max="$jmoment().format($dateFormat['en'])"
                    :clearable="!state.userInfo.authorized"
                    :disabled="readonly"
                    type="date"

                />
                <custom-input placeholder="کد ملی" type="text" :getValue.sync="data.nationalCode"  maxlength="10"  :disabled="readonly" typeValue="number"/>
                <custom-input placeholder="تلفن همراه" type="text" @getValue="getval" maxlength="11" typeValue="number"/>
                <custom-input placeholder="تلفن ثابت" type="text" @getValue="value => data.telephone = value" maxlength="11" typeValue="number"/>
                <custom-input address="true" placeholder="آدرس" type="text" @getValue="value => data.address = value" typeValue="text"/>

      </form> -->

      <div class="cont">
        <div class="row">
          <input
            type="text"
            class="public-input"
            v-model="data.firstName"
            @input="data.firstName = $S2Fa(data.firstName)"
            :disabled="readonly"
            placeholder="نام"
          />
          <input
            type="text"
            class="public-input"
            @input="data.lastName = $S2Fa(data.lastName)"
            placeholder="نام خانوادگی"
            v-model="data.lastName"
            :disabled="readonly"
          />

          <date-picker
            class="main-box"
            v-model="data.birthDay"
            placeholder="تاریخ تولد"
            :format="$dateFormat['en']"
            :display-format="$dateFormat['fa']"
            :max="$jmoment().format($dateFormat['en'])"
            :clearable="!state.userInfo.authorized"
            :disabled="readonly"
            type="date"
          />
        </div>
        <div class="row">
          <input
            class="public-input"
            type="text"
            @input="data.nationalCode = $A2N(data.nationalCode)"
            placeholder="کد ملی"
            v-model="data.nationalCode"
            :disabled="readonly"
            maxlength="10"
          />
          <input
            type="text"
            class="public-input"
            @input="data.mobileNumber = $A2N(data.mobileNumber)"
            placeholder="شماره موبایل"
            v-model="data.mobileNumber"
            maxlength="11"
          />
          <input
            type="text"
            class="public-input"
            v-model="data.telephone"
            @input="data.telephone = $A2N(data.telephone)"
            placeholder="شماره ثابت"
            maxlength="11"
          />
        </div>
        <input type="text" class="public-input address" v-model="data.address" placeholder="ادرس" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "../tools/custom-input";
import "@/styles/birthdayPicker.scss";
export default {
  name: "the-personal-info",
  components: { CustomInput },
  props: ["data"],


  computed: {
    readonly() {
      return [
        "AUTHORIZED",
        "INFORMATION_CHANGED",
        "INFORMATION_CHANGED_PENDING",
      ].includes(this.state.userInfo.authenticationType);
    },
  },
mounted(){
  console.log(this.state.userInfo.authenticationType)
}
};
</script>

<style lang="scss" scoped>
.address{
  height: 52px;
}
.cont {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.row {
  gap: 20px;
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  input {
    z-index: 1;
    flex-grow: 1;
    flex-basis: 100px;
    max-width: 332px;
    // width: 33%;
    min-height: 52px;
    max-height: 52px;
  }
}
.personal-info {
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    font-size: clamp(16px, 1vw, 22px);
    color: #ffffff;

    img {
      width: 74px;
      height: 74px;
      margin-right: -10px;
    }
  }

  .box {
    position: relative;
    padding: 40px;

    &::after {
      background-image: url("../../assets/backgrounds/kyc-BOX.png");
      background-size: auto;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      content: "";
      z-index: 0;
      opacity: 0.4;
      width: 100%;
      height: 100%;
      border-radius: 20px;
    }

    form {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 20px 50px;
    }
  }
}
</style>
